import React from 'react'
import {EmptyList} from '../../common/EmptyList'

interface IDdlResultProps {
  id: string
}

const DdlResult: React.FC<IDdlResultProps> = ({id}) => {
  return (
    <div id={id} className={'custom-scroll h-100 pt-x2 pr-x1 pl-x2 mr-x1'}>
      <div className={'task-tab-content d-flex flex-column justify-content-center custom-scroll'}>
        <EmptyList type={'DEV'} isMobileImg title={'В разработке'} />
      </div>
    </div>
  )
}

export {DdlResult}
